<template>
  <div class="subhead">
    <h3>Career with Us</h3>
    <p2>Join a team that believes in<br />carrying what matters.</p2>
  </div>
</template>

<script>
export default {
  name: "CareeringSubheader",
  props: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {},
  mounted() {},
};
</script>

<style>
.subhead {
  text-align: center;
  margin-bottom: 2.4rem;
}

.subhead p2 {
  color: #D2D2D2;
}
</style>
